export default __webpack_public_path__ + "static/Crossbow-89fa414f876c04e80f032883aeb30874.png";